enum MapStyle {
	Graphic,
	Satellite,
}
export default MapStyle;
